import React from 'react'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG } from '../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  disabled?: boolean
  children?: React.ReactNode
  isOpen?: boolean
  onToggle?: () => void
}

const AsideMenuItemWithSub: React.FC<Props> = ({
  children, to, title, icon, hasBullet, disabled, isOpen = false, onToggle,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)

  return (
    <div className={`amis-item${isOpen ? ' amis-item--open' : ''}${disabled ? ' amis-item--disabled' : ''}`}>
      <div
        className={`ami-link amis-trigger${isActive ? ' ami-link--active' : ''}`}
        onClick={() => !disabled && onToggle?.()}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        {hasBullet && <span className='ami-bullet' />}
        {icon && (
          <span className='ami-icon'>
            <KTSVG path={icon} className='svg-icon-4' />
          </span>
        )}
        <span className='ami-title'>{title}</span>
        <span className={`amis-arrow${isOpen ? ' amis-arrow--open' : ''}`}>
          <svg width='10' height='10' viewBox='0 0 10 10' fill='none'>
            <path d='M2.5 3.5L5 6.5L7.5 3.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </span>
      </div>

      <div className={`amis-sub${isOpen ? ' amis-sub--open' : ''}`}>
        {children}
      </div>
    </div>
  )
}

export { AsideMenuItemWithSub }